module.exports = __webpack_public_path__ + "img/JP_Tagline_white.2b267900.png";